import React from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import {
  Container,
  UserProfileRow,
  SectionHeading,
  ContentRow
} from './ShimmerExchangeRateCard.styles';
import { ShimmerExchangeRateCardProps } from './ShimmerExchangeRateCard.types';
import { ShimmerExchangeRateGraph } from '../ShimmerExchangeRateGraph/ShimmerExchangeRateGraph';
import { ShimmerCurrencyCalculator } from '../ShimmerCurrencyCalculator/ShimmerCurrencyCalculator';
import { skeletonProps } from '../Shimmer.types';

export const ShimmerExchangeRateCard = ({ width, height }: ShimmerExchangeRateCardProps) => {
  return (
    <Container $width={width} $height={height}>
      <UserProfileRow>
        <Skeleton circle width={48} height={48} {...skeletonProps} />
        <Skeleton width={90} height={18} {...skeletonProps} />
        <Skeleton width={24} height={24} {...skeletonProps} />
      </UserProfileRow>
      <SectionHeading>
        <Skeleton width={220} height={19} {...skeletonProps} />
      </SectionHeading>
      <ContentRow>
        <ShimmerExchangeRateGraph />
        <ShimmerCurrencyCalculator />
      </ContentRow>
    </Container>
  );
};
